import * as common from './common.json';

export const nl = {
  common,
};
